// Central date formatter — Phase 9.1
// Formato visible en TODA la app: DD-MM-YYYY (fechas), DD-MM-YYYY HH:MM (fecha+hora, 24h local).
// NO tocar inputs <input type="date"> ni el shape ISO del backend.

function _extractYMD(iso) {
    if (typeof iso !== "string") return null;
    // Fast path: matches YYYY-MM-DD prefix (works for both "2026-07-15" and "2026-07-15T…")
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return { y: m[1], mo: m[2], d: m[3] };
    return null;
}

export function formatDate(iso) {
    if (!iso) return "—";
    const ymd = _extractYMD(iso);
    if (ymd) return `${ymd.d}-${ymd.mo}-${ymd.y}`;
    // Fallback: Date parse in UTC
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    const dd = String(d.getUTCDate()).padStart(2, "0");
    const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
    const yyyy = d.getUTCFullYear();
    return `${dd}-${mm}-${yyyy}`;
}

export function formatDateTime(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    // Show date in DD-MM-YYYY using the local calendar day of the parsed timestamp
    // (so a full ISO "…T22:15:00Z" displays with the LOCAL day/hour).
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const HH = String(d.getHours()).padStart(2, "0");
    const MM = String(d.getMinutes()).padStart(2, "0");
    return `${dd}-${mm}-${yyyy} ${HH}:${MM}`;
}

// Backwards-compat aliases used across the codebase.
export const fmtDate = formatDate;
export const fmtDateTime = formatDateTime;
export const fmtDateShort = formatDate; // "short" (sin año) queda obsoleto → forzamos DD-MM-YYYY
